import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import NonTokenRoute from './NonTokenRoute';
import DashboardTemplate from 'app/templates/dashboard-template';
import { RoleListPage, RoleFormPage } from 'features/management/role';
// DEPRECATED: ManagementUser — migrated to features/management/user
// DEPRECATED: CompareBillEstimate, CompareSimilarBillEstimate — legacy pages removed (SA-1394)
import { TariffBookListPage as ListBukuTarif } from 'features/buku-tarif/list';
import {
  LogListPage as BukuTarifLogListPage,
  LogDetailPage as BukuTarifLogDetailPage,
} from 'features/admin-logs/buku-tarif-log';
import { NoInternet } from 'shared/ui/error-pages/no-internet';
// DEPRECATED: DetailPolis — legacy page removed (SA-1394)
import { checkMenus } from 'shared/lib/authUtils';
import { MENU, ACTION, routeIfAllowed } from 'shared/lib/permissions';
import { ADMISSION_METHOD } from 'shared/constants';
import { ClaimFeatureGuard } from 'features/claim/shared/components/claim-feature-guard';
import { PolicyOverviewPage } from 'features/policy-overview';
const InsuranceClaimLogListPage = lazy(() =>
  import('features/admin-logs/insurance-claim-log').then((m) => ({
    default: m.LogListPage,
  }))
);
const InsuranceClaimLogDetailPage = lazy(() =>
  import('features/admin-logs/insurance-claim-log').then((m) => ({
    default: m.LogDetailPage,
  }))
);

const NoAccessPage = lazy(() =>
  import('shared/ui/error-pages/no-access-page/NoAccessPage').then((m) => ({
    default: m.default,
  }))
);
const ExpiredLinkPage = lazy(() =>
  import('shared/ui/error-pages/expired-link-page/ExpiredLinkPage').then(
    (m) => ({
      default: m.default,
    })
  )
);
const Login = lazy(() =>
  import('features/auth').then((m) => ({ default: m.LoginPage }))
);
const SendResetLinkPage = lazy(() =>
  import('features/auth').then((m) => ({ default: m.SendResetLinkPage }))
);
const NewPasswordPage = lazy(() =>
  import('features/auth').then((m) => ({ default: m.NewPasswordPage }))
);
const ApplyClaimPage = lazy(() =>
  import('features/claim/apply-claim').then((m) => ({
    default: m.ApplyClaimPage,
  }))
);
// DEPRECATED: ApplyCashlessClaim — legacy page removed (SA-1394)
const ApplyClaimInpatientCashlessPage = lazy(() =>
  import('features/claim/apply-claim').then((m) => ({
    default: m.ApplyClaimInpatientCashlessPage,
  }))
);
// DEPRECATED: ApplyClaimInputManual — legacy page removed (SA-1394)
const ClaimHistoryPage = lazy(() =>
  import('features/claim/claim-history').then((m) => ({
    default: m.ClaimHistoryPage,
  }))
);
const TpaClaimsPage = lazy(() =>
  import('features/claim/tpa-claims').then((m) => ({
    default: m.TpaClaimsPage,
  }))
);
const MultipleClaim = lazy(() =>
  import('features/claim/multiple-claim').then((m) => ({
    default: m.MultipleClaimPage,
  }))
);
const ReimbursementDetailPage = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.ReimbursementDetailPage,
  }))
);
const ClaimHistoryDetailPage = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.ClaimHistoryDetailPageVSA,
  }))
);
const TpaDetailPage = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.TpaDetailPage,
  }))
);
const WebviewDetailPage = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.WebviewDetailPage,
  }))
);
const DetailCashlessClaim = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.DetailCashlessClaimPage,
  }))
);
const ClaimDetailStp = lazy(() =>
  import('features/claim/claim-detail').then((m) => ({
    default: m.ClaimDetailStpPage,
  }))
);
// DEPRECATED: DetailBukuTarifInsurance — legacy page removed (SA-1394)
const UploadBukuTarif = lazy(() =>
  import('features/buku-tarif/upload').then((m) => ({
    default: m.UploadTariffBookPage,
  }))
);
const DetailMenuBukuTarif = lazy(() =>
  import('features/buku-tarif/detail').then((m) => ({
    default: m.TariffBookDetailPage,
  }))
);
// DEPRECATED: SuperAdminDetailLogInsuranceClaim — migrated to features/admin-logs/insurance-claim-log
// DEPRECATED: SuperAdminDetailLogBukuTarif — migrated to features/admin-logs/buku-tarif-log
const DetailPolicyOverviewPage = lazy(() =>
  import('features/policy-overview/detail').then((m) => ({
    default: m.DetailPolicyOverviewPage,
  }))
);
const AnalyticsDashboard = lazy(() => import('features/analytics-dashboard'));
const QcAnalyticsDashboard = lazy(
  () => import('features/analytics-dashboard/qc-dashboard')
);
const ClaimListPage = lazy(() =>
  import('features/claim/claim-list').then((m) => ({
    default: m.ClaimListPage,
  }))
);
const UserListPage = lazy(() =>
  import('features/management/user').then((m) => ({
    default: m.UserListPage,
  }))
);
const CompanyListPage = lazy(() =>
  import('features/management/company').then((m) => ({
    default: m.CompanyListPage,
  }))
);
const CompanyDetailPage = lazy(() =>
  import('features/management/company').then((m) => ({
    default: m.CompanyDetailPage,
  }))
);
const ClaimConfigTemplate = lazy(
  () => import('app/templates/claim-config-template')
);
const ClaimConfigClaimListPage = lazy(() =>
  import('features/claim/claim-configuration').then((m) => ({
    default: m.ClaimConfigClaimListPage,
  }))
);
const ClaimConfigDetailPage = lazy(() =>
  import('features/claim/claim-configuration').then((m) => ({
    default: m.ClaimConfigDetailPage,
  }))
);
const ClaimConfigStpDetailPage = lazy(() =>
  import('features/claim/claim-configuration').then((m) => ({
    default: m.ClaimConfigStpDetailPage,
  }))
);
const ClaimConfigQualityCheckerPage = lazy(() =>
  import('features/claim/claim-configuration').then((m) => ({
    default: m.ClaimConfigQualityCheckerPage,
  }))
);
const ClaimConfigQcDetailPage = lazy(() =>
  import('features/claim/claim-configuration').then((m) => ({
    default: m.ClaimConfigQcDetailPage,
  }))
);
const PolicyManagementPage = lazy(() =>
  import('features/policy-management').then((m) => ({
    default: m.PolicyManagementPage,
  }))
);
const GroupPolicyDetailPage = lazy(() =>
  import('features/policy-management').then((m) => ({
    default: m.GroupPolicyDetailPage,
  }))
);
const PolicyDetailPage = lazy(() =>
  import('features/policy-management').then((m) => ({
    default: m.PolicyDetailPage,
  }))
);
const ClinicalPathwayDetailPage = lazy(() =>
  import('features/policy-management').then((m) => ({
    default: m.ClinicalPathwayDetailPage,
  }))
);
const QualityCheckerPage = lazy(() =>
  import('features/claim/quality-checker').then((m) => ({
    default: m.QualityCheckerPage,
  }))
);
const QcCreateClaimPage = lazy(() =>
  import('features/claim/quality-checker').then((m) => ({
    default: m.QcCreateClaimPage,
  }))
);
const QcDetailClaimPage = lazy(() =>
  import('features/claim/quality-checker').then((m) => ({
    default: m.QcDetailClaimPage,
  }))
);

// Single module-load read of the decrypted menus (same timing/staleness as the
// previous findMenuAccess calls — evaluated once at module load). Each route is
// gated below via routeIfAllowed against the Permission Access Layer registry.
const menus = checkMenus() ?? [];

// Two initiate routes were gated by (can_create || can_update) on the insurance
// portal menu. routeIfAllowed is single-action, so resolve the OR once here and
// reuse it for both routes — preserving the original combined gate exactly.
const canInitiateClaim =
  Boolean(routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.CREATE, true)) ||
  Boolean(routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.UPDATE, true));

export const SembuhRoutes = createBrowserRouter([
  {
    path: '*',
    name: '',
    element: <NoAccessPage />,
  },
  {
    path: '/expired-link',
    name: '',
    element: <ExpiredLinkPage />,
  },
  {
    path: '/',
    name: '',
    element: <NonTokenRoute />,
    children: [
      {
        path: '/',
        name: '',
        element: <Login />,
      },
      {
        path: '/login',
        name: '',
        element: <Login />,
      },
      {
        path: '/forgot-password/send-reset-link',
        name: '',
        element: <SendResetLinkPage />,
      },
      {
        path: '/forgot-password/new-password',
        name: '',
        element: <NewPasswordPage />,
      },
      {
        path: '/no-network',
        name: '',
        element: <NoInternet />,
      },
      {
        name: 'insurance portal detail web view',
        path: '/web-view/insurance-portal/outpatient/:id',
        element: <WebviewDetailPage type="outpatient" />,
      },
      {
        name: 'insurance portal detail web view',
        path: '/web-view/insurance-portal/inpatient/:id',
        element: <WebviewDetailPage type="inpatient" />,
      },
    ],
  },
  {
    path: '/',
    name: '',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        name: '',
        element: <DashboardTemplate />,
        children: [
          routeIfAllowed(menus, MENU.ANALYTICS, ACTION.READ, {
            path: '/analytics-dashboard',
            name: 'Analytics Dashboard',
            element: <AnalyticsDashboard />,
          }),
          routeIfAllowed(menus, MENU.QC_ANALYTICS_DASHBOARD, ACTION.READ, {
            path: '/qc-analytics-dashboard',
            name: 'QC Dashboard Analytics',
            element: <QcAnalyticsDashboard />,
          }),
          routeIfAllowed(menus, MENU.POLICY_OVERVIEW, ACTION.READ, {
            path: '/policy-overview',
            name: 'Policy Overview',
            element: <PolicyOverviewPage />,
          }),
          routeIfAllowed(menus, MENU.POLICY_OVERVIEW, ACTION.READ, {
            path: '/policy-overview/:id',
            name: 'Policy Overview',
            element: <DetailPolicyOverviewPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            path: '/history-claim',
            name: 'History Claim',
            element: <ClaimHistoryPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            path: '/insurance-portal',
            name: 'insurance portal',
            element: <ClaimListPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.CREATE, {
            path: '/insurance-portal/create',
            name: 'insurance portal create',
            element: (
              <ClaimFeatureGuard>
                <ApplyClaimPage />
              </ClaimFeatureGuard>
            ),
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.CREATE, {
            path: '/insurance-portal/multiple-claim/create',
            name: 'insurance portal multiple claim create',
            element: (
              <ClaimFeatureGuard>
                <MultipleClaim />
              </ClaimFeatureGuard>
            ),
          }),
          canInitiateClaim && {
            path: '/insurance-portal/initiate/:id',
            name: 'insurance portal initiate',
            element: <ApplyClaimPage />,
          },
          canInitiateClaim && {
            path: '/history-claim/initiate/:id',
            name: 'history claim initiate',
            element: <ApplyClaimPage />,
          },
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            name: 'history claim detail',
            path: '/history-claim/detail/:id',
            element: <ClaimHistoryDetailPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            path: '/tpa-claims',
            name: 'TPA Claims',
            element: <TpaClaimsPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            name: 'tpa claim detail',
            path: '/tpa-claims/detail/:id',
            element: <TpaDetailPage type="outpatient" />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            name: 'tpa claim detail inpatient',
            path: '/tpa-claims/inpatient/detail/:id',
            element: <DetailCashlessClaim />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            name: 'insurance portal detail',
            path: '/insurance-portal/detail/:id',
            element: (
              <ClaimFeatureGuard method={ADMISSION_METHOD.REIMBURSEMENT}>
                <ReimbursementDetailPage type="outpatient" />
              </ClaimFeatureGuard>
            ),
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.CREATE, {
            path: '/insurance-portal/inpatient-cashless/create',
            name: 'insurance portal inpatient cashless create',
            element: (
              <ClaimFeatureGuard method={ADMISSION_METHOD.CASHLESS}>
                <ApplyClaimInpatientCashlessPage />
              </ClaimFeatureGuard>
            ),
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.CREATE, {
            path: '/insurance-portal/inpatient-cashless/create/:id',
            name: 'insurance portal inpatient cashless create',
            element: (
              <ClaimFeatureGuard method={ADMISSION_METHOD.CASHLESS}>
                <ApplyClaimInpatientCashlessPage />
              </ClaimFeatureGuard>
            ),
          }),
          routeIfAllowed(menus, MENU.INSURANCE_PORTAL, ACTION.READ, {
            name: 'insurance portal detail inpatient',
            path: '/insurance-portal/detail/inpatient/:id',
            element: (
              <ClaimFeatureGuard method={ADMISSION_METHOD.CASHLESS}>
                <ClaimDetailStp />
              </ClaimFeatureGuard>
            ),
          }),
          routeIfAllowed(menus, MENU.BUKU_TARIF, ACTION.READ, {
            name: 'buku tarif',
            path: '/buku-tarif',
            element: <ListBukuTarif />,
          }),
          routeIfAllowed(menus, MENU.BUKU_TARIF, ACTION.READ, {
            name: 'buku tarif detail',
            path: '/buku-tarif/detail/:id',
            element: <DetailMenuBukuTarif />,
          }),
          routeIfAllowed(menus, MENU.BUKU_TARIF, ACTION.CREATE, {
            name: 'buku tarif upload',
            path: '/buku-tarif/upload',
            element: <UploadBukuTarif />,
          }),
          routeIfAllowed(menus, MENU.ROLE_MANAGEMENT, ACTION.READ, {
            name: 'management role',
            path: '/management-role',
            element: <RoleListPage />,
          }),
          routeIfAllowed(menus, MENU.ROLE_MANAGEMENT, ACTION.CREATE, {
            name: 'management role create',
            path: '/management-role/create-role',
            element: <RoleFormPage />,
          }),
          routeIfAllowed(menus, MENU.ROLE_MANAGEMENT, ACTION.UPDATE, {
            name: 'management role edit',
            path: '/management-role/edit-role/:id',
            element: <RoleFormPage />,
          }),
          routeIfAllowed(menus, MENU.USER_MANAGEMENT, ACTION.READ, {
            name: 'management user',
            path: '/management-user',
            element: <UserListPage />,
          }),
          {
            name: 'management company',
            path: '/management-company',
            element: <CompanyListPage />,
          },
          {
            name: 'management company detail',
            path: '/management-company/:id',
            element: <CompanyDetailPage />,
          },
          routeIfAllowed(menus, MENU.BUKU_TARIF_LOG, ACTION.READ, {
            name: 'buku tarif log',
            path: '/buku-tarif-log',
            element: <BukuTarifLogListPage />,
          }),
          routeIfAllowed(menus, MENU.BUKU_TARIF_LOG, ACTION.READ, {
            name: 'buku tarif log detail',
            path: '/buku-tarif-log/super-admin/:idClaim',
            element: <BukuTarifLogDetailPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_CLAIM_LOG, ACTION.READ, {
            name: 'insurance claim log',
            path: '/insurance-claim-log',
            element: <InsuranceClaimLogListPage />,
          }),
          routeIfAllowed(menus, MENU.INSURANCE_CLAIM_LOG, ACTION.READ, {
            name: 'insurance claim log detail',
            path: '/insurance-claim-log/super-admin/:idClaim',
            element: <InsuranceClaimLogDetailPage />,
          }),
          {
            name: 'Policy Management',
            path: '/policy-management/:companyId',
            element: <PolicyManagementPage />,
          },
          {
            name: 'Group Policy Detail',
            path: '/policy-management/:companyId/group/:groupId',
            element: <GroupPolicyDetailPage />,
          },
          {
            name: 'Policy Detail',
            path: '/policy-management/:companyId/detail/:policyId',
            element: <PolicyDetailPage />,
          },
          {
            name: 'Group Policy Document Detail',
            path: '/policy-management/:companyId/group/:groupId/detail/:policyId',
            element: <PolicyDetailPage />,
          },
          {
            name: 'Clinical Pathway Detail',
            path: '/policy-management/:companyId/pathway/:pathwayId',
            element: <ClinicalPathwayDetailPage />,
          },
          {
            name: 'quality checker',
            path: '/quality-checker',
            element: <QualityCheckerPage />,
          },
          {
            name: 'quality checker create',
            path: '/quality-checker/create',
            element: <QcCreateClaimPage />,
          },
          {
            name: 'quality checker initiate',
            path: '/quality-checker/initiate/:id',
            element: <QcCreateClaimPage />,
          },
          {
            name: 'quality checker detail',
            path: '/quality-checker/detail/:id',
            element: <QcDetailClaimPage />,
          },
          {
            path: '/no-network',
            name: '',
            element: <NoInternet />,
          },
        ].filter(Boolean),
      },
      // Konfigurasi Klaim (SA-1862) — super-admin area launched from the
      // company detail page. Sibling of DashboardTemplate, not a child: it
      // carries its own two-menu sidebar, so the application sidebar must not
      // mount here.
      //
      // Access resolves through MENU.CLAIM_CONFIGURATION -> aliasOf
      // COMPANY_MANAGEMENT, which only exists for a super admin; every other
      // role drops the route and falls through to NoAccessPage.
      //
      // Deliberately NOT wrapped in <ClaimFeatureGuard>: that guard reads the
      // *logged-in user's* company feature flags, which belong to the wrong
      // company here, and a miss redirects to /insurance-portal — ejecting the
      // super admin out of this shell entirely.
      routeIfAllowed(menus, MENU.CLAIM_CONFIGURATION, ACTION.READ, {
        path: '/claim-configuration/:companyId',
        name: 'claim configuration',
        element: <ClaimConfigTemplate />,
        children: [
          {
            index: true,
            element: <Navigate to="insurance-portal" replace />,
          },
          {
            path: 'insurance-portal',
            name: 'claim configuration insurance portal',
            element: <ClaimConfigClaimListPage />,
          },
          {
            path: 'insurance-portal/detail/:id',
            name: 'claim configuration claim detail',
            element: <ClaimConfigDetailPage />,
          },
          {
            path: 'insurance-portal/detail/inpatient/:id',
            name: 'claim configuration claim detail inpatient',
            element: <ClaimConfigStpDetailPage />,
          },
          {
            path: 'quality-checker',
            name: 'claim configuration quality checker',
            element: <ClaimConfigQualityCheckerPage />,
          },
          {
            path: 'quality-checker/detail/:id',
            name: 'claim configuration quality checker detail',
            element: <ClaimConfigQcDetailPage />,
          },
        ],
      }),
      {
        path: '/change-password/send-reset-link',
        name: '',
        element: <SendResetLinkPage />,
      },
      {
        path: '/change-password/new-password',
        name: 'change password',
        element: <NewPasswordPage />,
      },
      // routeIfAllowed returns false for a role without access; drop those.
    ].filter(Boolean),
  },
]);
